import React from 'react'
import Page from '../../components/Page'
import { DollarSign } from 'lucide-react'
import { AIAssistantButton } from '../../components/AIAssistant'

const CostsTrendsPage: React.FC = () => {
  // Contexto normalizado para Custos
  const screenContext = 'Costs'

  return (
    <Page
      title="💰 Tendências de Custos"
      subtitle="Análise de tendências e evolução dos custos"
      onRefresh={() => window.location.reload()}
    >
      {/* AI Assistant Button */}
      <AIAssistantButton screenContext={screenContext} />

      <div className="w-full h-full flex items-center justify-center">
        <div className="text-center">
          <DollarSign
            className="h-16 w-16 mx-auto mb-4"
            style={{ color: 'var(--primary)' }}
          />
          <h2
            className="text-2xl font-semibold mb-2"
            style={{ color: 'var(--text-primary)' }}
          >
            Tendências de Custos - Em Desenvolvimento
          </h2>
          <p
            style={{ color: 'var(--text-secondary)' }}
          >
            Esta página será implementada em breve
          </p>
        </div>
      </div>
    </Page>
  )
}

export default CostsTrendsPage
